import { CredentialContextVersion, DATA_INTEGRITY_V2_URL, STATUS_LIST_2021_CREDENTIAL_URL } from '@trustvc/w3c-context';
import { _checkCredentialSubjectForBitstringStatusListCredential, _checkCredentialSubjectForStatusList2021Credential } from './BitstringStatusList/assertions';
import { getValidFromDateFromCredentialStatusVC, assertCredentialStatusStatusListType } from './utils';

var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
const VCCredentialStatusTypeToVCCredentialSubjectType = {
  StatusList2021Credential: "StatusList2021",
  BitstringStatusListCredential: "BitstringStatusList"
};
const createCredentialStatusPayload = /* @__PURE__ */ __name(async (options, keyPair, type = "BitstringStatusListCredential", cryptoSuite = "ecdsa-sd-2023") => {
  try {
    const { id, credentialSubject } = options;
    if (cryptoSuite === "BbsBlsSignature2020") {
      throw new Error("BbsBlsSignature2020 is no longer supported. Please use the latest cryptosuite versions instead.");
    }
    switch (type) {
      case "StatusList2021Credential":
        _checkCredentialSubjectForStatusList2021Credential(credentialSubject);
        break;
      case "BitstringStatusListCredential":
        _checkCredentialSubjectForBitstringStatusListCredential(credentialSubject);
        break;
      default:
        throw new Error(`Unsupported type: ${type}`);
    }
    if (!credentialSubject.id && id) {
      credentialSubject.id = `${id}#list`;
    }
    const isV2 = type === "BitstringStatusListCredential";
    const context = [
      isV2 ? CredentialContextVersion.v2 : CredentialContextVersion.v1
    ];
    context.push(DATA_INTEGRITY_V2_URL);
    if (type === "StatusList2021Credential") {
      context.push(STATUS_LIST_2021_CREDENTIAL_URL);
    }
    const validFrom = await getValidFromDateFromCredentialStatusVC(id);
    const vc = {
      "@context": context,
      type: [
        "VerifiableCredential",
        type
      ],
      issuer: keyPair.controller,
      ...isV2 ? {
        validFrom
      } : {
        issuanceDate: (/* @__PURE__ */ new Date()).toISOString(),
        validFrom
      },
      credentialSubject
    };
    return vc;
  } catch (err) {
    if (!(err instanceof Error)) {
      throw new Error("An error occurred while signing the credential status VC.");
    }
    throw err;
  }
}, "createCredentialStatusPayload");
const isCredentialStatusStatusList = /* @__PURE__ */ __name((credentialStatus) => {
  try {
    assertCredentialStatusStatusListType(credentialStatus?.type);
    return true;
  } catch (err) {
    return false;
  }
}, "isCredentialStatusStatusList");

export { VCCredentialStatusTypeToVCCredentialSubjectType, createCredentialStatusPayload, isCredentialStatusStatusList };
